export type Brand = 'stiebel' | 'tecalor';

export const BRAND_CONFIG = {
  stiebel: {
    name: 'ServiceWelt',
    demoName: 'ServiceWelt Demo',
    title: 'Stiebel Eltron Servicewelt',
    headerTitle: 'ServiceWelt',
    clientAppHeader: 'ServiceWelt',
    appName: 'MyStiebel',
    companyName: 'STIEBEL ELTRON GmbH & Co. KG',
    imprintUrl: '',
  },
  tecalor: {
    name: 'tecalor Pro',
    demoName: 'tecalor Pro Demo',
    title: 'tecalor Pro Portal',
    headerTitle: 'tecalor Pro',
    clientAppHeader: 'TecalorServiceWelt',
    appName: 'tecalor',
    companyName: 'tecalor GmbH',
    imprintUrl: 'https://waermepumpe.tecalor.de/de/info/impressum.html',
  },
} as const;

const BRAND_STORAGE_KEY = 'SW.brand';

function isBrand(value: unknown): value is Brand {
  return value === 'stiebel' || value === 'tecalor';
}

export function detectBrand(): Brand {
  const hostname = window.location.hostname;
  if (hostname.includes('tecalor')) { return 'tecalor'; }
  try {
    const stored = localStorage.getItem(BRAND_STORAGE_KEY);
    if (isBrand(stored)) { return stored; }
  } catch {
    // localStorage unavailable
  }
  return 'stiebel';
}

export const currentBrand = detectBrand();
export const brandConfig = BRAND_CONFIG[currentBrand];
export const isTecalor = currentBrand === 'tecalor';

/**
 * Tag to wrap caption-style emphasis text in. Stiebel uses `<strong>` for bold;
 * tecalor renders the same caption in regular weight per Figma spec, so the
 * tag falls through to Translated's default `<span>`.
 */
export const emphasisTagName: 'strong' | undefined = isTecalor ? undefined : 'strong';
